import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Flex } from "@chakra-ui/react/flex";
import { Spinner } from "@chakra-ui/react/spinner";
import { AiChatProvider } from "components/ai-chats/AiChatProvider";
import { Provider as ChakraProvider } from "components/ui/provider";
import { WebSocketProvider } from "hooks/use-socket";
import React from "react";
import { Outlet } from "react-router-dom";

const PrivateRoot = () => {
  return (
    <WebSocketProvider>
      <AiChatProvider>
        <Outlet />
      </AiChatProvider>
    </WebSocketProvider>
  );
};

export default withAuthenticationRequired(PrivateRoot, {
  returnTo: () => {
    return window.location.pathname;
  },
  onRedirecting: () => {
    return (
      <ChakraProvider>
        <Flex alignItems="center" justifyContent="center" h="100%" w="100%">
          <Spinner size="xl" />
        </Flex>
      </ChakraProvider>
    );
  },
});
